import { render } from "./DeatailParams.vue?vue&type=template&id=086f68f6&scoped=true"
import script from "./DeatailParams.vue?vue&type=script&lang=js"
export * from "./DeatailParams.vue?vue&type=script&lang=js"

import "./DeatailParams.vue?vue&type=style&index=0&id=086f68f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086f68f6"]])

export default __exports__